import { Badge } from '@/components/ui/Badge'
import type { TransactionStatus } from '../types'

const VARIANT: Record<TransactionStatus, React.ComponentProps<typeof Badge>['variant']> = {
  successful: 'success',
  pending: 'pending',
  failed: 'failed',
  declined: 'failed',
  cancelled: 'cancelled',
  reversed: 'cancelled',
  on_hold: 'pending',
}

const LABEL: Record<TransactionStatus, string> = {
  successful: 'Successful',
  pending: 'Pending',
  failed: 'Failed',
  declined: 'Declined',
  cancelled: 'Cancelled',
  reversed: 'Reversed',
  on_hold: 'On hold',
}

/**
 * Status chip used in the detail view header *and* the transaction list,
 * so it must stay self-contained and visually consistent — same component,
 * same colors everywhere.
 */
export function StatusChip({ status }: { status: TransactionStatus }) {
  return <Badge variant={VARIANT[status]}>{LABEL[status]}</Badge>
}
